import Vue from "vue";
import { Main } from "./components/Main";
var v = new Vue({
    el: "#app",
    template: "<Main></Main>",
    data: { name: "World" },
    components: {
        Main: Main
    }
});
